import React, { Component } from 'react';
import $ from 'jquery';
import { Link } from 'react-router';
import {connect} from 'react-redux';
import ReactStars from 'react-stars';
import * as actions from './../../../actions';
import { Panel } from 'react-bootstrap';
import { ShareButtons,generateShareIcon } from 'react-share';

const {FacebookShareButton,GooglePlusShareButton,TwitterShareButton} = ShareButtons;
const FacebookIcon = generateShareIcon('facebook');
const TwitterIcon = generateShareIcon('twitter');
const GooglePlusIcon = generateShareIcon('google');

class Deal extends Component{
      constructor(){
        super();
        this.state={
          open: false,
          shareUrl: '',
          msg:'',
          regModalStatus: false,
          err_reg: '',
          reg_err_status: false,
          loginModalStatus: false,
          signupModalStatus: false,
        };
        this.ShareFunc=this.ShareFunc.bind(this);
        // this.regRedirect=this.regRedirect.bind(this);
        this.onMobileChange=this.onMobileChange.bind(this);
        this.getDeviceId=this.getDeviceId.bind(this);

      }

    getDeviceId()
    {
        if(localStorage.user_id)
        {
            var user_id=localStorage.user_id;
        }
        else
        {
          user_id=0;
        }
        var data1={from: 'desktop_web',id: user_id, device_id: localStorage.getItem('push_device_id')}
        var data2=JSON.stringify(data1);
        var baseUrl='https://aquadeals.in/admin/web3/user/';
        $.ajax({
            method: 'POST',
            url: baseUrl+'getDeviceId',
            dataType: 'json',
            data:{req: data2},
            success: function(data)
            {
            },
            error: function(err)
            {
            }
        });
    }
    // componentWillReceiveProps(newProps)
    // {
    //    if(newProps.formdata.status === 'success')
    //    {
    //         this.setState({showAddModal_Login: false})
    //         this.setState({showAddModal_signup: false})
    //         this.setState({showAddModal_otp_signup: false})
    //    }
    // }          
    
  ShareFunc(evnt)
  {
      var baseUrl='https://aquadeals.in/admin/web3/user/';
      var data1={from: 'desktop_web',type:0,did:evnt};
      var data2=JSON.stringify(data1);
      $.ajax({
            method: 'POST',
            url: baseUrl+'createTinyurl',
            dataType:'json',
            data: {req:data2},
            success: function(data)
            {
                this.setState({
                  msg: data.msg,
                  shareUrl: data.tinyurl,
                })
            }.bind(this),
            error: function(err)
            {
              // console.log("Error"+err);
            }
      });
      this.setState({
        open: !this.state.open 
      });
      setTimeout(() => {this.setState({open: false}); }, 5000);
  }
  // regRedirect(sdetails,name,id)
  // {
  //     localStorage.removeItem('w_r_seed_deals');
  //     localStorage.setItem('w_modal_seed','/web/sdetails/'+name+"/"+id);
  //     if(localStorage.token && localStorage.user_id)
  //     {
  //         browserHistory.push(localStorage.w_modal_seed);
  //         window.location.reload();
  //     }
  //     else
  //     {
  //         // this.setState({ showAddModal_Login: true})
  //         browserHistory.push('/web/login');
  //     }
  // }

  
  onMobileChange(event)
  {
      var invalidChars = /[^0-9]/gi;
      if(invalidChars.test(event.target.value)) 
      {
          event.target.value = event.target.value.replace(invalidChars,"");
      }
      else
      {
          this.setState({
            reg_err_status: true,
          })
      }
  }

  render(){
    var myDeals=this.props.data;
    var shareUrl=this.state.shareUrl;
    var title="Hey! Click here "+ shareUrl + " to check "+ myDeals.deals_data.sname + " from AquaDeals.";
    var description=shareUrl;

    return(
      <div>
         <div className="col-md-3 col-sm-6">
            <div className="">
              {myDeals.promo_ribbion ? <i className="webribbon_img"><img src={'https://aquadeals.in/admin/assets/images/web_imgs/'+myDeals.promo_ribbion} alt="ribbon" /></i> : ''}
            </div>
            <div className="prdt_blk">
               <Link className="lst_share_btn" onClick={()=>{this.ShareFunc(myDeals.deals_data.id)}}>
                      <img src={'https://aquadeals.in/admin/assets/images/web_imgs/share-icon.png'} alt="Share" />
               </Link>
               <Panel className="share_panel" collapsible expanded={this.state.open}>
                         <FacebookShareButton url={shareUrl} quote={title} description={description} className="test_share">
                              <FacebookIcon size={32} round />
                         </FacebookShareButton>
                         <TwitterShareButton url={shareUrl} quote={title} description={description} className="test_share">
                              <TwitterIcon size={32} round />
                         </TwitterShareButton>
                         <GooglePlusShareButton url={shareUrl} quote={title} descirption={description} className="test_share">
                              <GooglePlusIcon  size={32} round />
                         </GooglePlusShareButton>
               </Panel>
               <Link to={"/web/sdetails/"+myDeals.deals_data.sname+"/"+myDeals.deals_data.id}>
                  <div className="seed_image">
                      <img  src={'https://aquadeals.in/admin/assets/images/seller_imgs/thumbnails/'+myDeals.deals_data.image} alt="Seed" />
                  </div>
                   {myDeals.deals_data.sname ? <h3>{myDeals.deals_data.sname}</h3> : <h3>&nbsp;</h3>}
                   {myDeals.deals_data.oname ? <h4 >{myDeals.deals_data.oname}</h4> : <h4>&nbsp;</h4>}
                   {myDeals.offer > 0 ? <h4><span></span><span>&#8377; {myDeals.offer}</span> off on 1M</h4> : '' }
                   {/* {myDeals.deals_data.discount_price > 0 ? <p className="web_seed_p_ofr"><span></span><span>&#8377; {myDeals.offer}</span> off on 1M</p> : '' }*/}
                   {/* {myDeals.deals_data.discount_price > 0 ? <p><span>&#8377;{myDeals.deals_data.price}</span>&nbsp;<span>&#8377;{myDeals.deals_data.discount_price}</span></p> : <p><span></span><span>&#8377;{myDeals.deals_data.price}</span></p> }  */}
                   {myDeals.deals_data.price ? <h4><span></span><span style={{color:'#333'}}>&#8377;</span><span style={{color:'#333'}}> {myDeals.deals_data.price}</span></h4> : ''} 
               </Link> 
               <div className="row stars_view_blk">
                      <div className="col-md-7 col-xs-7" style={{paddingRight:'0'}}>
                        <div className="prdt_str_rt">
                          <ReactStars
                              count={5}
                              className={'webRate_blk_item'}
                              size={17}
                              value={myDeals.deals_data.rate >=1 ? myDeals.deals_data.rate : 0}
                              edit={false}
                              color1={'#ccc'}
                              color2={'#ffc50a'}
                          />
                        </div>
                      </div>
                      <div className="col-md-5 col-xs-5"  style={{paddingLeft:0}}>
                         {myDeals.view_status >0 ?<span className="prdt_views"><i><img src={'https://aquadeals.in/admin/assets/images/web_imgs/eye.png'} width="16px" role="presentation"/></i>&nbsp;{myDeals.view_status}</span>:<span>&nbsp;</span>}
                      </div>  
                  </div>              

            </div>
         </div>
        </div> 
      );
  }
}

function mapStateToProps(state){
  return {
    errorMessage:state.auth.error,
    authenticated:state.auth.authenticated,
    formdata:state.auth.formdata,
    formdata_log:state.auth.formdata_log,
  };
}

export default connect(mapStateToProps,actions)(Deal);


/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Seed/modules/Sead_deal_list.js
 **/